export default {
    STUDENT: 0,
    GROUP_LEADER: 1,
    NETWORK_LEADER: 2,
    ADMIN: 3
}